import * as React from 'react';
import { SVGProps } from 'react';

export const Seng = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4454_84566)">
      <path
        d="M31.9932 17.3629C31.9932 17.2795 31.9723 17.203 31.9444 17.1264C31.9375 17.1125 31.9306 17.0986 31.9236 17.0917C31.9027 17.0499 31.8818 17.0082 31.854 16.9735L27.1315 10.7348V4.7813C27.1385 2.49312 25.3997 0.69873 23.1811 0.69873H9.15982C6.83682 0.69873 4.87551 2.56961 4.87551 4.7813V11.1313L0.160009 16.9526C0.118279 17.0013 0.0904369 17.0569 0.0626603 17.1125L0.0556836 17.1195C0.0278418 17.196 0.00697675 17.2795 0.00697675 17.356C0.00697675 17.363 0 17.3769 0 17.3839V30.5775C0 30.9253 0.250381 31.2382 0.591198 31.287C1.02936 31.3565 1.39796 31.0227 1.39796 30.6054V25.7369H30.609V30.5845C30.609 30.9322 30.8594 31.2452 31.2002 31.2939C31.6314 31.3565 32.0001 31.0227 32.0001 30.6054V17.3907C32.0001 17.3838 31.9932 17.3768 31.9932 17.3629ZM6.26655 4.7813C6.26655 3.34859 7.61581 2.08971 9.15982 2.08971H23.1672C24.6069 2.08971 25.7406 3.27204 25.7406 4.7813V10.4357H6.26655V4.7813ZM6.09963 11.8267H26.2135L29.9066 16.6952H2.16305L6.09963 11.8267ZM30.6091 24.3457H1.39802V18.0862H30.6091V24.3457Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_4454_84566">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Seng;
